import { Link, useRouterState } from '@tanstack/react-router';
import { cn } from 'cn';

const TABS = [
  { to: '/ledger', label: 'Transactions' },
  { to: '/ledger/patrimoine', label: 'Patrimoine' },
  { to: '/ledger/bilan', label: 'Bilan annuel' },
  { to: '/ledger/prevision', label: 'Prévision' },
] as const;

export function LedgerTabs() {
  const pathname = useRouterState({ select: (state) => state.location.pathname });

  return (
    <nav aria-label="Ledger" className="flex gap-2 border-b border-border">
      {TABS.map((tab) => {
        const active = pathname === tab.to;
        return (
          <Link
            key={tab.to}
            to={tab.to}
            aria-current={active ? 'page' : undefined}
            className={cn(
              'border-b-2 px-3 py-2 text-sm font-medium text-muted-foreground transition-colors hover:text-foreground',
              active ? 'border-primary text-foreground' : 'border-transparent',
            )}
          >
            {tab.label}
          </Link>
        );
      })}
    </nav>
  );
}
